import React from "react";
import { HiOutlineSquare3Stack3D } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import JSubCategoriesTable from "./home/table";
import JSubCategoriesHeader from "./home/header";
import { setPageDialog } from "../../../../app/slices/jomla/subcategorySlice";
import FormDialog from "../../../../components/FormDialog";

const JSubCategories = () => {
  const _JSubCategories = useSelector((state) => state.JSubCategories);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setPageDialog());
  };

  return (
    <FormDialog
      open={_JSubCategories.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineSquare3Stack3D />}
      title="الاقسام الفرعية"
      maxWidth="lg"
    >
      <JSubCategoriesHeader />
      <JSubCategoriesTable />
    </FormDialog>
  );
};

export default JSubCategories;
